import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { loginRequest } from "../../api/azure/authConfig";
import { callMsGraph } from "../../api/azure/msGraphAPI";
import { getDeploymentStatus } from "../../api/users/configApi";
import altimetrikLogo from "../../assets/images/altimetrik-logo.png";
import iacLogo from "../../assets/svg/iac-logo.svg";
import Carousel from "../../components/carousel";
import LoadingButton from "../../elements/LoadingButton";
import { clearCache } from "../../utils/storage";
import { imageData } from "./imageData";
import InitialLogin from "./initialLogin";
import { useStyles } from "./styles";

export default function SignIn() {
  const classes = useStyles();
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [graphData, setGraphData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isInitial, setIsInitial] = useState(false);

  useEffect(() => {
    async function checkStatus() {
      const status = await getDeploymentStatus();
      setIsInitial(status === "FIRST_RUN");
    }
    checkStatus();
  }, []);

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then((response) => setGraphData(response))
        .catch((e) => {
          if (e instanceof InteractionRequiredAuthError) {
            clearCache();
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount(),
            });
          }
        });
    }
  }, [inProgress, graphData, instance]);

  const handleSubmit = (e) => {
    setLoading(true);
    clearCache();
    instance.loginRedirect(loginRequest);
  };

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  const settings = {
    dots: true,
    speed: 500,
    autoplaySpeed: 4000,
    arrows: false,
    autoplay: true,
    infinite: true,
    containerProps: { className: classes.slideContainer },
    dotsClass: classes.loginSlickDots,
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.leftView}>
        <Carousel settings={settings}>
          {imageData.map((ele) => {
            return (
              <div key={ele.title}>
                <div className={`carousel-slide ${classes.slideContainer}`}>
                  <img src={ele.image} alt="login-slide" />
                  <div className={classes.textCarousel}>
                    <h2>{ele.title || ""}</h2>
                    <span>{ele.description || ""}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </Box>
      <Box className={classes.rightView}>
        <img
          className={classes.logo}
          src={altimetrikLogo}
          alt="altimetrik-logo"
        />
        <Box className={classes.body}>
          <img src={iacLogo} alt="iac-logo" />
          <Typography fontWeight={600} sx={{ fontSize: "28px" }}>
            Infrastructure as Code
          </Typography>
          <Typography sx={{ fontSize: "14px", marginTop: "-8px" }}>
            Write-back your Infrastructure to code.
          </Typography>
          {isInitial ? (
            <InitialLogin />
          ) : (
            <LoadingButton
              loading={loading}
              disabled={loading}
              className={classes.loginBtn}
              onClick={handleSubmit}
              variant="contained"
              label=" Sign-in with AZURE AD"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
